import styled, { css, keyframes } from 'styled-components'


const fadeIn = keyframes`
    from { opacity: 0; transform: translateY(-8px); }
    to { opacity: 1; transform: translateY(0); }
`

const fadeOut = keyframes`
    from { opacity: 1; transform: translateY(0); }
    to { opacity: 0; transform: translateY(8px); }
`

export const Container = styled.ul`
    margin-top: 20px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 10px;
    max-height: calc(100vh - 400px); 

    li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #444;
        animation: ${fadeIn} 0.25s ease forwards;

        &.removing {
            animation: ${fadeOut} 0.25s ease forwards;
        }

        & + li {
            margin-top: 15px;
        }
    }
`

export const FileInfo = styled.div`
    display: flex;
    align-items: center;

    div{
        display: flex;
        flex-direction: column;

        span{
            font-size: 12px;
            color: #999;
            margin-top: 5px;

            button{
                border: 0;
                background: transparent;
                color: #e57878;
                margin-left: 5px;
                cursor: pointer;
            }
        }
    }
`

export const FileStatus = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`

const sizes = {
    sm: 28,
    md: 36,
    lg: 44,
}

export const DownloadButton = styled.button`
    display: inline-grid;
    place-items: center;
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    border-radius: .28571429rem;
    transition: background-color 120ms ease, transform 120ms ease;

    ${({ size = 'md' }) => css`
        width: ${sizes[size]}px;
        height: ${sizes[size]}px;
    `}

    &:hover {
        background: rgba(0, 0, 0, 0.06);
    }

    &:active {
        background: rgba(0, 0, 0, 0.12);
    }

    &:focus {
        outline: 2px solid rgba(21, 156, 228, 0.8);
        outline-offset: 2px;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.45;
    }
`
